import React, {useEffect, useMemo} from "react";
import {useSelector, useDispatch} from 'react-redux';
import PropTypes from "prop-types";
import { indigo, green, amber, red } from "@material-ui/core/colors";
import {
  Grid,
} from "@material-ui/core";
import TableComponentBackPagination from "views/Widgets/Common/TableComponentBackPagination";
import { ButtonTextTemplate as Button } from "utils/componentsStyle";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");


// eslint-disable-next-line react/prop-types
export default function RequestTable({
  dataArray,
  handleClickDetails,
  title,
  handleEnableAddress,
  handleEnableAddressContracts,
  handleEnableAddressWarehouse,
  handleDecompetation,
  handleRewriteTelemedicina,
  handleRequestTelemedicina,
  handleProgressExtra,
  handleUploadAutorizationPending,
  handleDocumentoFaltante,
  handleAprobacionGescaec,
  handleResumenSolicitud,
  handlesTransport,
  setOpenModalExam,
  setOpenModalRequestExam,
  setOpenModalUploadAuthorization,
  setOpenModalWaitingContract,
  setOpenModalToPerform,
  setOpenModalUploadAuthorizationAntibiotic,
  setOpenModalPreviewRequestEquipment,
  setOpenModalUploadOrderAntibiotic,
  setOpenModalRequestAntibiotic,
  setOpenModalUploadOrderPersonalClinico,
  setTempRow,
  handleInsumos,
  handleReplacementMedicine,
  setOpenModalAddAuthorization,
  handleCheckEquipment,
  setopenModalAddAuthorizationQuotation,
  setopenModalAddAuthorizationProfExtra,
  setopenModalEditProfExtra,
  setopenModalTabletLose,
  setopenModalAlertStock,
  setopenModalAsssingWorks,
  setopenRouteWorks,
  setTipoTarea,
  setopenCheckEquip,
  totalCount,
  page,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
  orderBy,
  orderType,
  onOrderChange,
  columnFilters,
  onColumnFilterChange,
}) {
  // Estados finalizados: el backend ya filtra las tareas por grupo (proceso/espera/
  // finalizado) al traerlas, esta lista solo se usa aca para decidir la accion del
  // click sobre una fila (ver handleClick).
  const endStateArray = [
    "Completado",
    "Realizada",
    "RealizadaAtraso",
    "NoRealizada",
    "CanceladaPaciente",
    "Cancelada",
    "Finalizado"
  ];

  const dictStateWork = useSelector(state => state.currentList.DICCIONARIO_ESTADO_TAREAS_FICHA);
  const dictTypeWork = useSelector(state => state.currentList.DICCIONARIO_TIPO_TAREAS_FICHA);

  const headerTable = [
    {eval: true, label: "ID solicitud"},
    {eval: true, label: "ID tarea"},
    {eval: true, label: "Tipo de Tarea"},
    {eval: true, label: "Solicitado por"},
    {eval: true, label: "Paciente"},
    {eval: true, label: "Fecha inicio/término"},
    {eval: true, label: "Estado"},
    {eval:false, label: "Acciones"}
  ]

  const diasAtrasoColor = (dias) => {
    if (dias === null || dias === undefined) return null;
    if (dias <= 0) return green[500];
    if (dias <= 2) return amber[700];
    return red[500];
  };

  const handleClick = (row, index) => {

    if (row.tipo_tarea === "VisitaInicial" && row.id_solicitud_paciente && row.id_tarea_padre === null && (row.estado === "EsperandoConfirmacion" || row.estado === "Incompleto")){
      handleClickDetails(row, index)
    } else if (row.tipo_tarea === "HabilitacionDomicilioContratos" && row.id_solicitud_paciente && (row.estado === "SubirContratos" || row.estado === "PorRealizar" || row.estado === "GestionarContratos")){
      handleEnableAddressContracts(row)
    } else if (row.tipo_tarea === "HabilitacionDomicilioSecretaria" && row.id_solicitud_paciente && row.estado === "PorRealizar"){
      handleEnableAddressWarehouse(row)
    } else if (row.tipo_tarea === "HabilitacionDomicilio" && row.id_solicitud_paciente && row.estado === "PorRealizar" ){
      handleEnableAddress(row)
    } else if (row.tipo_tarea === "Examen" && row.estado === "EnCoordinadorEnfermeria" ){
      setTempRow(row);
      setOpenModalExam(true);
    } else if (row.tipo_tarea === "Examen" && row.estado === "SubirAutorizacionIsapre"){
      setTempRow(row);
      setOpenModalUploadAuthorization(true);
    } else if (row.tipo_tarea === "Examen" && row.estado === "EsperandoContrato"){
      setTempRow(row);
      setOpenModalWaitingContract(true);
    } else if (row.tipo_tarea === "Examen" && row.estado === "PorRealizar"){
      setTempRow(row);
      setOpenModalToPerform(true);
    } else if (row.tipo_tarea === "Examen" && row.estado === "SubirOrdenExamenes"){
      setTempRow(row);
      setOpenModalRequestExam(true);
    } else if (row.tipo_tarea === "ExamenLaboratorio" && row.estado === "ExamenDatosEntrega"){
      setTempRow(row);
      setOpenModalWaitingContract(true);
    } else if (row.tipo_tarea === "ExamenLaboratorio" && row.estado === "SubirResultadosExamen"){
      setTempRow(row);
      setOpenModalToPerform(true);
    } else if (row.tipo_tarea === "Descompensacion" && row.id_solicitud_paciente && (row.estado === "EsperandoInstrucciones" || row.estado === "InstruccionesEntregadas")){
      handleDecompetation(row);
    } else if (row.tipo_tarea === "SolicitudInsumos" && row.estado === "PorRealizar") {
      handleInsumos(row)
    } else if (row.tipo_tarea === "TrasladoAutorizacion" && row.estado === "SubirAutorizacionIsapre") {
      setOpenModalAddAuthorization(true);
      setTempRow(row);
    } else if (row.tipo_tarea === "SolicitudCotizacion" && row.estado === "SubirAutorizacionIsapre") {
      setopenModalAddAuthorizationQuotation(true);
      setTempRow(row);
    } else if (row.tipo_tarea === "TerapiaAntibiotico" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalRequestAntibiotic(true);
    } else if (row.tipo_tarea === "TerapiaAntibioticoAutorizacion" && row.estado === "PorRealizar" ) {
      setTempRow(row);
      setOpenModalUploadAuthorizationAntibiotic(true);
    } else if (row.tipo_tarea === "SolicitarEquipo" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalPreviewRequestEquipment(true);
      setTipoTarea("SolicitarEquipo");
    } else if (row.tipo_tarea === "ReemplazarEquipo" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalPreviewRequestEquipment(true);
      setTipoTarea("ReemplazarEquipo");
    } else if ( row.tipo_tarea === "RetirarEquipo" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalPreviewRequestEquipment(true);
      setTipoTarea("RetirarEquipo");
    } else if (row.tipo_tarea === "TerapiaAntibioticoOrden" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalUploadOrderAntibiotic(true);
    } else if (row.tipo_tarea === "PersonalClinicoOrden" && row.estado === "PorRealizar") {
      setTempRow(row);
      setOpenModalUploadOrderPersonalClinico(true);
    } else if ( (row.tipo_tarea === "ReemplazoMedicamento" || row.tipo_tarea === "ReemplazoMedicamentoGescaec") && row.estado === "Pendiente") {
      handleReplacementMedicine(row);
    } else if (row.tipo_tarea === "RevisionEquipo" && row.estado === "EsperandoRevisionEquipo") {
      handleCheckEquipment(row);
    } else if (row.tipo_tarea === "TranscribirLLamadaTelemedicina") {
      handleRewriteTelemedicina(row);
    } else if (row.tipo_tarea === "Telemedicina" ) {
      handleRequestTelemedicina(row);
    } else if (row.tipo_tarea === "TrasladosInsumosMedicamentos") {
      handlesTransport(row);
    } else if (row.tipo_tarea === "AutorizacionPersonalExtra" && row.estado === "PorRealizar") {
      setopenModalAddAuthorizationProfExtra(row);
    } else if  (row.tipo_tarea === "EditarExtra" && row.estado === "PorRealizar") {
      setopenModalEditProfExtra(row);
    } else if (row.tipo_tarea === "DispositivoExtraviado") {
      setopenModalTabletLose(row);
    } else if (row.tipo_tarea === "AlertaStock") {
      setopenModalAlertStock(row);
    } else if (row.tipo_tarea === "RespuestaCoordinador" && row.estado === "PorRealizar" || endStateArray.includes(row.estado)) {
      handleProgressExtra(row);
    } else if (row.tipo_tarea === "SubirAutorizacionIsaprePendiente"){
      handleUploadAutorizationPending(row);
    } else if (row.tipo_tarea === "DocumentoFaltante" && row.estado === "PorRealizar") {
      handleDocumentoFaltante(row);
    } else if (row.tipo_tarea === "SolicitudExamenes" && row.estado === "PorRealizar") {
      handleAprobacionGescaec(row);
    } else if (row.tipo_tarea === "ResumenSolicitud") {
      handleResumenSolicitud(row);
    } else if (row.tipo_tarea === "TrasladoAsignar" && row.estado ===  "Incompleto") {
      setopenModalAsssingWorks(row)
    } else if (row.tipo_tarea === "RevisionEquipoCoordinador") {
      setopenCheckEquip(row)
    } else if ([
      "Respiratorio", "AsignacionExtra", "MedHab",
      "CitaTelemedicina", "Asignacion", "SOS", "Descompensacion", "DescompensacionNoTens", "DescompSOS" , "DescompMedHab", "DescompRespiratorio",
      "ExamenAsignarNoTens","ExamenAsignarTens", "TerapiaAntibioticoAsignarTens", "TerapiaAntibioticoAsignarNoTens", "AsignacionExtra"
    ].includes(row.tipo_tarea)
    ){
      if (typeof setopenRouteWorks === "function") {
        setopenRouteWorks(row);
      } else {
        window.open(`/admin/patientDetail/${row.id_ficha.id_paciente.id}`)
      }
    } else {
      window.open(`/admin/patientDetail/${row.id_ficha.id_paciente.id}`)
    }
  }


  // handleClick no esta en las dependencias a proposito: se redefine en cada
  // render de RequestTable (no esta envuelto en useCallback), asi que
  // incluirlo invalidaria este useMemo en todos los renders y lo volveria
  // inutil. Su comportamiento no depende de nada que cambie entre renders
  // donde dataArray/dictTypeWork/dictStateWork siguen iguales (solo cierra
  // sobre props que son setState o handlers equivalentes entre renders), asi
  // que omitirlo es seguro en la practica.
  const dataTable = useMemo(() => dataArray.map((row, index) => {

    const _buttonAction_ = <Button
        size="sm"
        style={{ background: indigo[500] }}
        onClick={() => handleClick(row, index)}
      >
        Ver detalle
      </Button>

    let nameUserRequest = ""
    if (row?.id_solicitud_paciente?.id_persona_solicitante){
      const userRequest = row?.id_solicitud_paciente?.id_persona_solicitante;
      nameUserRequest = `${userRequest["first_name"]} ${userRequest["last_name"]}`
    }
    const diasAtraso = row.id_solicitud_paciente ? moment().diff(row.id_solicitud_paciente.fecha_creacion, "days") : null;
    return [
      {value: row.id_solicitud_paciente ? row.id_solicitud_paciente.id : "-"},
      {value: row.id},
      {value : dictTypeWork[row.tipo_tarea]? dictTypeWork[row.tipo_tarea].label : row.tipo_tarea},
      {_value_ : <>
        <div>{nameUserRequest || "-"}</div>
        <div>F solicitud: {row.id_solicitud_paciente ? moment(row.id_solicitud_paciente.fecha_creacion).format("YYYY-MM-DD") : "-"}</div>
      </>},
      {value : row?.id_ficha?.id_paciente ? `${row.id_ficha.id_paciente.nombre} ${row.id_ficha.id_paciente.apellido_paterno} ${row.id_ficha.id_paciente.apellido_materno}` : `No disponible`},
      {_value_ : <>
        <div>F inicio: {row.fecha_hora ? moment(row.fecha_hora).format("YYYY-MM-DD HH:mm") : "-"}</div>
        <div>F fin: {row.fecha_final ? moment(row.fecha_final).format("YYYY-MM-DD HH:mm") : "-"}</div>
        {diasAtraso !== null &&
          <span style={{
            display: "inline-block",
            marginTop: "4px",
            padding: "2px 8px",
            borderRadius: "12px",
            color: "#fff",
            fontSize: "0.75rem",
            fontWeight: "bold",
            backgroundColor: diasAtrasoColor(diasAtraso),
          }}>
            {diasAtraso} {diasAtraso === 1 ? "día" : "días"} de atraso
          </span>
        }
      </>},
      {value : dictStateWork[row.estado]?.label || row.estado},
      {_value_ : _buttonAction_},
    ]
  }), [dataArray, dictTypeWork, dictStateWork]);

  return (
    <Grid item xs={12} style={{ margin: "30px 0 0 0" }}>
      <TableComponentBackPagination
        headers={headerTable}
        data={dataTable}
        size={'small'}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        orderBy={orderBy}
        orderType={orderType}
        onOrderChange={onOrderChange}
        columnFilters={columnFilters}
        onColumnFilterChange={onColumnFilterChange}
      />
    </Grid>
  );
}

RequestTable.propTypes = {
  dataArray: PropTypes.array,
  totalCount: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  orderBy: PropTypes.number,
  orderType: PropTypes.string,
  onOrderChange: PropTypes.func,
  columnFilters: PropTypes.array,
  onColumnFilterChange: PropTypes.func,
};
